<template>
  <div class="flex flex-col lg:flex-row w-full mt-6 mb-6">
    <!-- Left: Certificate Data -->
    <div class="w-full lg:w-1/2 bg-white p-5 lg:mr-3 rounded shadow-md">
      <div class="mt-6">
        <div class="flex items-center">
          <h3 class="uppercase text-lg font-semibold text-primary tracking-wide">Certificate Data</h3>
          <hr class="flex-grow border-primary ml-4" />
        </div>

        <div class="flex flex-wrap -my-3 mx-1 mt-4">
          <div class="flex flex-col w-full sm:w-1/2 lg:w-1/3 my-3 px-5">
            <label class="uppercase font-semibold text-sm">Design Load Capacity</label>
            <input
                v-model="form.load_proof.design_load_capacity"
                class="bge-input bge-input-spacing rounded"
                name="design_load_capacity"
                type="text"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- Right: Statement -->
    <div class="w-full lg:w-1/2 bg-white p-5 lg:ml-3 rounded shadow-md">
      <div class="mt-6">
        <div class="flex items-center">
          <h3 class="uppercase text-lg font-semibold text-primary tracking-wide">Certificate Statement</h3>
          <hr class="flex-grow border-primary ml-4" />

          <div class="flex justify-end ml-2">
            <AppButton v-if="!editMode" color="blue" label="" @click="enableEdit" :icon="true" class="mr-2">
              <template #icon>
                <Icon iconType="edit" />
              </template>
            </AppButton>
            <AppButton v-if="editMode" color="blue" label="" @click="saveChanges" :icon="true" class="mr-2">
              <template #icon>
                <Icon iconType="save" />
              </template>
            </AppButton>
            <AppButton v-if="editMode" color="gray" label="" @click="cancelEdit" :icon="true">
              <template #icon>
                <Icon iconType="close" />
              </template>
            </AppButton>
          </div>
        </div>

        <div v-if="editMode">
          <Editor v-model="editableStatement" editorStyle="height: 120px" :options="editorOptions">
            <template #toolbar>
              <span class="ql-formats">
                <button class="ql-bold"></button>
                <button class="ql-italic"></button>
                <button class="ql-underline"></button>
                <button class="ql-list" value="ordered"></button>
                <button class="ql-list" value="bullet"></button>
              </span>
            </template>
          </Editor>
        </div>
        <div v-else class="bg-gray-100 p-4 rounded-md mt-6">
          <div v-html="form.statement"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppButton from '@/components/Button.vue';
import Icon from '@/components/Icon.vue';
import notificationMixin from "@/mixins/notificationMixin";

function blankForm() {
  return {
    load_proof: { design_load_capacity: '' },
    statement: ''
  };
}

export default {
  name: 'LoadProofCertificate',
  mixins: [notificationMixin],
  components: { AppButton, Icon },
  props: {
    calibration_details: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ['update:calibration_details'],
  data() {
    return {
      form: blankForm(),
      editMode: false,
      editableStatement: '',
      editorOptions: {
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline'],
            [{ list: 'ordered' }, { list: 'bullet' }],
          ]
        },
        theme: 'snow'
      },
      hasUserEdited: false
    };
  },
  mounted() {
    this.seedFrom(this.calibration_details);
  },
  watch: {
    calibration_details: {
      deep: true,
      immediate: true,
      handler(val) {
        if (!val) return;
        if (this.hasUserEdited) return;
        this.seedFrom(val);
      }
    },
    editableStatement(val) {
      this.form.statement = val || '';
    },
    form: {
      deep: true,
      handler(v) {
        this.hasUserEdited = true;
        this.$emit('update:calibration_details', JSON.parse(JSON.stringify(v)));
      }
    }
  },
  methods: {
    seedFrom(src) {
      const safe = src && typeof src === 'object' ? src : {};
      const lp = safe.load_proof && typeof safe.load_proof === 'object' ? safe.load_proof : {};

      this.form = {
        load_proof: {
          design_load_capacity:
              typeof lp.design_load_capacity !== 'undefined' ? lp.design_load_capacity : ''
        },
        statement:
            typeof safe.statement !== 'undefined' ? safe.statement : ''
      };

      this.editableStatement = this.form.statement;
      this.hasUserEdited = false;
    },
    getCurrentData() {
      return JSON.parse(JSON.stringify(this.form));
    },
    enableEdit() { this.editMode = true; },
    saveChanges() { this.editMode = false; },
    cancelEdit() {
      this.editMode = false;
      this.editableStatement = this.form.statement || '';
    }
  }
};
</script>

